// 프로필 이미지 S3 원본 URL(path-style)을 CDN(cloudfront) URL로 변환한다.
// 예) https://s3.ap-northeast-2.amazonaws.com/mildang/data/xxx.jpg
//   → https://d2b8xhxnbw3abm.cloudfront.net/data/xxx.jpg
//
// 주의: mildangS3ToCDN(ListeningPlayer)은 virtual-hosted 형식(mildang.s3...)을 처리하므로
// path-style인 profileUrl에는 맞지 않아 별도 함수로 둔다.
const PROFILE_S3_ORIGIN = 'https://s3.ap-northeast-2.amazonaws.com/mildang';
const PROFILE_CDN_ORIGIN = 'https://d2b8xhxnbw3abm.cloudfront.net';

export function profileImageToCdn(url?: string | null): string | null | undefined {
  if (!url) return url;
  // 이미 CDN이거나 다른 형식이면 그대로 반환(idempotent)
  return url.startsWith(PROFILE_S3_ORIGIN) ? url.replace(PROFILE_S3_ORIGIN, PROFILE_CDN_ORIGIN) : url;
}

// 프로필 미설정 상태를 나타내는 기본 이미지 URL(S3 원본).
// User.profileUrl은 String!(항상 문자열)이며, 빈문자열 또는 이 기본 이미지면 "미등록"으로 본다.
export const DEFAULT_PROFILE_IMAGE_URL =
  'https://s3.ap-northeast-2.amazonaws.com/mildang/users/profile/default.png';

// 프로필 이미지 미설정 여부. 미설정이면 소비처는 이미지 대신 이니셜 fallback을 표시한다.
// createCache의 merge가 mildang 타깃에서 기본 이미지도 CDN URL로 바꾸므로, S3/CDN 어느 형태로
// 저장돼 있든 동일하게 판별하도록 profileImageToCdn으로 정규화한 뒤 비교한다.
export function isUnsetProfileUrl(url?: string | null): boolean {
  if (!url) return true;
  return profileImageToCdn(url) === profileImageToCdn(DEFAULT_PROFILE_IMAGE_URL);
}

// profileUrl을 이미지 src로 넘길 때 표시 지점에서 사용하는 헬퍼(미설정 fallback 전용).
// 미설정('' 또는 기본 이미지)이면 undefined → Avatar 이니셜 fallback + next/image 빈 src 에러 방지.
// CDN 변환은 여기서 하지 않는다 — Apollo cache의 User.profileUrl merge가 쓰기 시점에 처리한다.
export function resolveProfileImageSrc(url?: string | null): string | undefined {
  return isUnsetProfileUrl(url) ? undefined : (url ?? undefined);
}

export default profileImageToCdn;
